'use client';
import Link from 'next/link';
import React from 'react';
import Logo from '../logo/logo';
import { aboutPages, industryPages, servicePages } from '../__data__/nav-data';
import SocialIcons from '../social-icons/social-icons';

const year = new Date().getFullYear();

export const Footer = () => {
    return (
        <div className="bg-gray-900">
            <div className="w-full mx-auto max-w-container">
                <div className="mx-6 md:grid md:mx-0 md:grid-cols-14">
                    <div className="md:col-span-12 md:col-start-2">
                        <div className="pt-20 pb-10">
                            <div className="block grid-cols-1 grid-rows-2 gap-0 md:grid md:gap-8 md:grid-rows-1 md:grid-cols-14">
                                <div className="col-span-1 md:col-span-5 xl:col-span-6">
                                    <div className="w-48 lg:w-64">
                                        <Logo mode="light" />
                                    </div>
                                    <ul className="my-8 space-y-4 leading-relaxed text-white md:mb-0">
                                        <li className="mb-4">
                                            <a
                                                className="after:bg-white border-b-in group"
                                                href="https://www.google.com/maps/place/Foster+Made/@37.5426455,-77.4409035,17z/data=!4m12!1m6!3m5!1s0x89b1110f90a1ab8f:0xd4cc3bb48e585cd0!2sFoster+Made!8m2!3d37.5426455!4d-77.4387148!3m4!1s0x89b1110f90a1ab8f:0xd4cc3bb48e585cd0!8m2!3d37.5426455!4d-77.4387148?hl=en-US"
                                            >
                                                404 E Grace St
                                                <br />
                                                Richmond, VA 23219
                                            </a>
                                        </li>
                                        <li className="mb-4">
                                            <a className="after:bg-white border-b-in" href="mailto:hello@fostermade.co">
                                                hello@fostermade.co
                                            </a>
                                        </li>
                                        <li>
                                            <a className="after:bg-white border-b-in" href="tel:18042913999">
                                                804.291.3999
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="mt-8">
                                        <SocialIcons color="white" />
                                    </div>
                                    <a
                                        href="/partners-and-platforms/mach"
                                        className="inline-block mt-10"
                                        aria-label="Member of the MACH Alliance"
                                    >
                                        <img
                                            src="/images/mach-alliance-member.svg"
                                            alt="Member of the MACH Alliance"
                                            width={253}
                                            height={58}
                                            className="w-[253px] h-auto"
                                            loading="lazy"
                                        />
                                    </a>
                                </div>
                                <div className="mt-2 mb-10 text-white md:col-span-3 md:mb-0">
                                    <h5 className="mb-4 text-white overline h5">Expertise</h5>
                                    <ul className="space-y-4 text-sm leading-tight lg:text-base">
                                        {servicePages.map((page) => (
                                            <li key={page.link}>
                                                <Link className="after:bg-white border-b-in" href={page.link}>
                                                    {page.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-start-2 mt-2 mb-10 text-white md:col-span-3 md:mb-0">
                                    <h5 className="mb-4 text-white overline h5">Industries</h5>
                                    <ul className="space-y-4 text-sm leading-tight lg:text-base">
                                        {industryPages.map((page) => (
                                            <li key={page.link}>
                                                <Link className="after:bg-white border-b-in" href={page.link}>
                                                    {page.label}
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="mt-2 text-white md:col-span-3 lg:col-span-3 xl:col-span-2">
                                    <h5 className="mb-4 text-white overline h5">Foster Made</h5>
                                    <ul className="space-y-4 text-sm leadingCD-tight lg:text-base">
                                        {aboutPages.map((page) => (
                                            <li key={page.link}>
                                                <Link className="after:bg-white border-b-in" href={page.link}>
                                                    {page.label}
                                                </Link>
                                            </li>
                                        ))}
                                        <li>
                                            <Link className="after:bg-white border-b-in" href="/case-studies">
                                                Case Studies
                                            </Link>
                                        </li>
                                        <li>
                                            <Link className="after:bg-white border-b-in" href="/contact">
                                                Contact
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="mt-12 border-t border-white md:mt-16">
                                <div className="grid grid-cols-12 mt-2 lg:gap-6 md:mt-0">
                                    <div className="order-2 col-span-12 mt-4 lg:order-1 lg:col-span-6">
                                        <p className="flex flex-col items-start text-xs text-white md:items-center md:flex-row">
                                            <span className="flex items-center">
                                                <span className="mr-1 text-lg mt-[3px]">&copy;</span>
                                                <span>{`Copyright ${year}. All Rights Reserved.`}</span>
                                            </span>
                                            <span className="block mt-2 md:mt-0 md:inline lg:ml-1">
                                                Made with &#9825; in Richmond, VA.
                                            </span>
                                        </p>
                                    </div>
                                    <div className="order-1 col-span-12 mt-4 lg:order-2 lg:col-span-6">
                                        <ul className="space-y-4 text-xs text-left text-white md:space-y-0 md:space-x-4 lg:text-right">
                                            <li className="block md:inline">
                                                <Link
                                                    href="/about/accessibility-statement"
                                                    className="pb-1 md:mb-0 after:bg-white border-b-in"
                                                >
                                                    Accessibility Statement
                                                </Link>
                                            </li>
                                            <li className="block md:inline">
                                                <Link
                                                    href="/about/privacy-policy"
                                                    className="pb-1 after:bg-white border-b-in lg:ml-6 md:mb-0"
                                                >
                                                    Privacy Policy
                                                </Link>
                                            </li>
                                            <li className="block md:inline">
                                                <Link
                                                    href="#"
                                                    className="pb-1 after:bg-white border-b-in lg:ml-6 md:mb-0"
                                                >
                                                    Terms & Conditions
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
